class CalendarHeaderItem {
	constructor(date, scale)
	{
		this.date = date
		this.scale = scale
	}	
}

export default CalendarHeaderItem